/* Ten Antennas — Contact drawer behaviour, on Dawn's drawer.

   REBUILT. The custom element that positioned itself never resolved to the
   viewport — measured at 1054×749 inside a 1440×813 window — so the panel, the
   overlay and every attempt at a shadow were anchored to the wrong box. This
   version drives Dawn's own drawer classes instead, exactly as cart-drawer.js
   does: `animate` enables the transition, `active` opens it. Dawn's stylesheet
   supplies the positioning, the overlay and the slide, all of which already
   work on this site.

   Opens on any link that means "contact us": the menu item, the footer menu,
   and the policy link in the copyright line. The href stays intact, so
   cmd-click, middle-click and no-JS visitors still reach the real page.

   NO SCROLL LOCK, deliberately — locking the document makes iOS Safari expand
   its toolbar, which switches off theme-color tinting and loses the visitor's
   place. */
(function () {
  if (window.__taContactDrawer) return;
  window.__taContactDrawer = true;

  var lastFocus = null;

  function el() {
    return document.getElementById('ContactDrawer');
  }

  function open(trigger) {
    var d = el();
    if (!d) return;
    lastFocus = trigger || document.activeElement;
    d.classList.add('animate', 'active');
    d.setAttribute('aria-hidden', 'false');
    var inner = d.querySelector('.drawer__inner');
    if (inner) setTimeout(function () { inner.focus(); }, 60);
  }

  function close() {
    var d = el();
    if (!d) return;
    d.classList.remove('active');
    d.setAttribute('aria-hidden', 'true');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function isContactLink(a) {
    if (!a) return false;
    var href = a.getAttribute('href') || '';
    return /\/pages\/contact(\/|$|\?|#)/.test(href) ||
           /\/policies\/contact-information/.test(href);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-contact-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var link = event.target.closest('a');
    if (!isContactLink(link)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();

    /* Close the menu panel first, or two sheets sit on top of each other. */
    document.querySelectorAll('details.mega-menu[open]').forEach(function (details) {
      var host = details.closest('header-menu');
      if (host && typeof host.close === 'function') host.close();
      else details.removeAttribute('open');
    });

    open(link);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var d = el();
    if (d && d.classList.contains('active')) close();
  });

  function boot() {
    var d = el();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');

    var posted = d.getAttribute('data-posted') === 'true' ||
                 /contact_posted=true/.test(window.location.search);
    if (posted) open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
